import { render } from "./LoyaltyPointsGenerator.vue?vue&type=template&id=2b676bca&scoped=true"
import script from "./LoyaltyPointsGenerator.vue?vue&type=script&lang=js"
export * from "./LoyaltyPointsGenerator.vue?vue&type=script&lang=js"

import "./LoyaltyPointsGenerator.vue?vue&type=style&index=0&id=2b676bca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b676bca"]])

export default __exports__